import { Component, OnInit, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, AlertService } from '@app/_services';
import { LogmanYieldMaxService } from '../../logman-yieldmax.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { PropertyService } from '@app/_components/property/property.service';
import * as moment from 'moment';
import { ConstantService } from '@app/_services/constant.service';
import { Reservation } from '@app/_components/reservation';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-logman-yieldmax',
    templateUrl: './logman-yieldmax.component.html',
    styleUrls: ['./logman-yieldmax.component.css'],
    standalone: false
})
export class LogmanYieldMaxComponent implements OnInit, OnChanges {

	form1: UntypedFormGroup;
	formLoading = false;
	formErrorMessage: string;
	properties: any;
	showReservationSearch = false;

	logman: any;
	logmanId: number;

	subscription: Subscription;

	validationMessages =
		{
			logmanId: [{ type: 'required', message: 'Required' }],
			createDate: [{ type: 'required', message: 'Required' }],
			lastUpdate: [{ type: 'required', message: 'Required' }],
			checkInDate: [{ type: 'required', message: 'Required' }],
			logmanDate: [{ type: 'required', message: 'Required' }],
			rating: [{ type: 'required', message: 'Required' }],
			ratingScale: [{ type: 'required', message: 'Required' }],

			// 1 approved / 2 suspended / 3 incomplete
			status: [{ type: 'required', message: 'Required' }],
			title: [{ type: 'required', message: 'Required' }],
			logmanDesc: [{ type: 'required', message: 'Required' }, { type: 'minlength', message: 'Minimum length is 50 characters' }],
			responseDesc: [{ type: 'required', message: 'Required' }],
			helpfulCount: [{ type: 'required', message: 'Required' }],
			notHelpfulCount: [{ type: 'required', message: 'Required' }],

			// logmaner
			firstName: [{ type: 'required', message: 'Required' }],
			lastName: [{ type: 'required', message: 'Required' }],
			emailAddress: [{ type: 'required', message: 'Required' }],
			screenName: [{ type: 'required', message: 'Required' }],
			city: [{ type: 'required', message: 'Required' }],
			state: [{ type: 'required', message: 'Required' }],
			country: [{ type: 'required', message: 'Required' }],

			// links
			propertyCode: [{ type: 'required', message: 'Required' }],
			shortTermRentalId: [{ type: 'required', message: 'Required' }],
			reservationId: [{ type: 'required', message: 'Required' }],
		};



	severities = [
		{ name: 'Error', value: 'ERROR' },
		{ name: 'Info', value: 'INFO' },
		{ name: 'Debug', value: 'DEBUG' },
		{ name: 'Report', value: 'REPORT' },
	];



	/*
	*
	*
	*/
	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private formBuilder: UntypedFormBuilder,
		private logmanYieldMaxService: LogmanYieldMaxService,
		private messageService: MessageService,
		private dynamicDialogRef: DynamicDialogRef,
		private dynamicDialogConfig: DynamicDialogConfig,
		private propertyService: PropertyService,
		private constants: ConstantService,
		private confirmationService: ConfirmationService
	) { }

	ngOnInit(): void {
		if (this.dynamicDialogConfig.data) {
			console.log("dynamicDialogConfig")
			// get the logman
			this.logman = this.dynamicDialogConfig.data.logman;
		}
		else {
			console.log("this.subscription")
			this.subscription = this.activatedRoute.params.subscribe(params => {
				this.logmanId = params.logmanId; // (+) converts string 'id' to a number
				this.logman = this.findLogmanById(this.logmanId);
			});

		}
	}

	ngOnChanges() { }

	onCloseClick() {
		// pass the logman back to the logman-list component to update the list.
		this.dynamicDialogRef.close(this.logman);
	}

	findLogmanById(logmanId: number) {
		this.formLoading = true;
		this.logmanYieldMaxService.findById(logmanId).pipe(first()).subscribe(
			res => {
				this.logman = res.data.logman;
			},
			err => {
				console.log('error In findLogmanById is: ' + JSON.stringify(err));
				this.formLoading = false;
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your logman: ' + err.message, sticky: true });
			},
			() => { this.formLoading = false; });
	}

	getSeverityName(logman: any) {
		const severity = this.severities.find(e => e.value === logman.severity);
		return severity.name;
	}

	getMessage(message) {
		return message.replace('\r', '<br>').replace('\n', '<br>');
	}

}
